module.exports = __webpack_public_path__ + "img/page-05.7666fc96.jpg";